import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading} from "../../../components/template/architecture";
import {BreadCrumbs} from "../../../components/open/pages";
import {GradeToString} from "../students/list";
import {ThinCallIcon} from "../../../components/icons/material-icons";
import {StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";

export const AdminsPresignupStudentDetails = () => {
    const {studentId} = useParams();
    const [data, setData] = useState({
        loaded: false,
        firstname: "",
        lastname: "",
        nationalCode: "",
        grade: 1,
        parentTell: "",
        prePaymentPrice: 0,
        approved: false,
        approvedAt: "2000-01-01 00:00:00",
        createdAt: "2000-01-01 00:00:00",
        birthSerial: "",
        declined: false,
        declinedAt: "2000-01-01 00:00:00",
        fatherName: "",
        motherName: "",
        fatherJob: "",
        motherJob: "",
        birthDate: "2000-01-01",
        address: "",
        homeTell: "",
        fatherCertificate: "",
        fatherTell: "",
        motherCertificate: "",
        zipcode: "",
        whoGetsSms: "father",
        livesWith: "both",
        emergencyTell: "",
        motherTell: "",
        isPaid: false,
        paidAt: "2000-01-01 00:00:00",
        oldSchool:'',
    });
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/admins/presignup/details',
            {
                id: studentId,
            },
            true,
            (d: {
                result: string,
                reason: string,
                firstname: string,
                lastname: string,
                nationalCode: string,
                grade: number,
                parentTell: string,
                prePaymentPrice: number,
                approved: boolean,
                approvedAt: string,
                createdAt: string,
                birthSerial: string,
                declined: boolean,
                declinedAt: string,
                fatherName: string,
                motherName: string,
                fatherJob: string,
                motherJob: string,
                birthDate: string,
                address: string,
                homeTell: string,
                fatherCertificate: string,
                fatherTell: string,
                motherCertificate: string,
                zipcode: string,
                whoGetsSms: string,
                livesWith: string,
                emergencyTell: string,
                motherTell: string,
                isPaid: boolean,
                paidAt: string,
                oldSchool:string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setData({
                    loaded: true,
                    firstname: d.firstname,
                    lastname: d.lastname,
                    nationalCode: d.nationalCode,
                    grade: d.grade,
                    parentTell: d.parentTell,
                    prePaymentPrice: d.prePaymentPrice,
                    approved: d.approved,
                    approvedAt: d.approvedAt,
                    createdAt: d.createdAt,
                    birthSerial: d.birthSerial,
                    declined: d.declined,
                    declinedAt: d.declinedAt,
                    fatherName: d.fatherName,
                    motherName: d.motherName,
                    fatherJob: d.fatherJob,
                    motherJob: d.motherJob,
                    birthDate: d.birthDate === '' ? '2000-01-01' : d.birthDate,
                    address: d.address,
                    homeTell: d.homeTell,
                    fatherCertificate: d.fatherCertificate,
                    fatherTell: d.fatherTell,
                    motherCertificate: d.motherCertificate,
                    zipcode: d.zipcode,
                    whoGetsSms: d.whoGetsSms,
                    livesWith: d.livesWith,
                    emergencyTell: d.emergencyTell,
                    motherTell: d.motherTell,
                    isPaid: d.isPaid,
                    paidAt: d.paidAt,
                    oldSchool: d.oldSchool,
                });
                document.title = d.firstname + " " + d.lastname + " | پیش ثبت‌نام | نهال";
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        fetchData();
    }, []);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'پیش ثبت‌نام', url: '/admins/presignup'},
                {
                    title: data.loaded ? `${data.firstname} ${data.lastname}` : '...',
                    url: `/admins/presignup/view/${studentId}`
                },
            ]}/>
            {
                data.loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="student-profile">
                                    <i style={{backgroundImage: 'url(https://techara-images.ir/u/default.png)'}}/>
                                    <b>{data.firstname + " " + data.lastname}</b>
                                    <span>{GradeToString(data.grade)}</span>
                                    <em data-color={data.approved ? 'blue' : 'red'}>
                                        {data.approved ? 'تایید شده' : (data.declined ? 'رد شده' : 'در انتظار تایید')}
                                    </em>
                                    <strong>{data.isPaid ? 'پرداخت شده' : 'پرداخت نشده'}</strong>
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="screen-card">
                                    <div className="screen-card-header">
                                        <b>مشخصات دانش‌آموز</b>
                                    </div>
                                    <div className="student-info">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <span>نام و نام‌خانوادگی:</span>
                                                <b>{data.firstname + " " + data.lastname}</b>
                                                <span>کدملی:</span>
                                                <b>{StringDigitsConvertToPersian(data.nationalCode)}</b>
                                                <span>پایه تحصیلی:</span>
                                                <b>{GradeToString(data.grade)}</b>
                                                <span>سریال شناسنامه:</span>
                                                <b>{data.birthDate === "" ? "نامشخص" : StringDigitsConvertToPersian(data.birthSerial)}</b>
                                                <span>تلفن منزل:</span>
                                                <b data-link="yes">
                                                    {StringDigitsConvertToPersian(data.homeTell)}
                                                    <a href={`tel:${data.homeTell}`}
                                                       className="open-tooltip">
                                                        <ThinCallIcon/>
                                                        <i>تماس تلفنی</i>
                                                    </a>
                                                </b>
                                                <span>تاریخ تولد:</span>
                                                <b>{StringDigitsConvertToPersian(GregorianToPersian(data.birthDate).replaceAll('-', '/'))}</b>
                                                <span>نام پدر:</span>
                                                <b>{data.fatherName}</b>
                                                <span>مدرک تحصیلی پدر:</span>
                                                <b>{data.fatherCertificate}</b>
                                                <span>دریافت‌کننده پیامک:</span>
                                                <b>{data.whoGetsSms === 'father' ? 'پدر' : (data.whoGetsSms === 'mother' ? 'مادر' : 'نامشخص')}</b>
                                                {
                                                    data.oldSchool.length > 0 ?
                                                        <>
                                                            <span>نام مدرسه قبلی:</span>
                                                            <b>{data.oldSchool}</b>
                                                        </> : null
                                                }
                                            </div>
                                            <div className="col-lg-6">
                                                <span>تلفن پدر:</span>
                                                <b>
                                                    {StringDigitsConvertToPersian(data.fatherTell.replaceAll('+98','0'))}
                                                    <a href={`tel:${data.fatherTell}`}
                                                       className="open-tooltip">
                                                        <ThinCallIcon/>
                                                        <i>تماس تلفنی</i>
                                                    </a>
                                                </b>
                                                <span>شغل پدر:</span>
                                                <b>{data.fatherJob}</b>
                                                <span>نام مادر:</span>
                                                <b>{data.motherName}</b>
                                                <span>تلفن مادر:</span>
                                                <b>
                                                    {StringDigitsConvertToPersian(data.motherTell.replaceAll('+98','0'))}
                                                    <a href={`tel:${data.motherTell}`}
                                                       className="open-tooltip">
                                                        <ThinCallIcon/>
                                                        <i>تماس تلفنی</i>
                                                    </a>
                                                </b>
                                                <span>مدرک مادر:</span>
                                                <b>{data.motherCertificate}</b>
                                                <span>شغل مادر:</span>
                                                <b>{data.motherJob}</b>
                                                <span>کدپستی:</span>
                                                <b>{StringDigitsConvertToPersian(data.zipcode)}</b>
                                                <span>نشانی منزل:</span>
                                                <b>{data.address}</b>
                                                <span>تلفن تماس اضطراری:</span>
                                                <b>
                                                    {StringDigitsConvertToPersian(data.emergencyTell.replaceAll('+98','0'))}
                                                    <a href={`tel:${data.emergencyTell}`}
                                                       className="open-tooltip">
                                                        <ThinCallIcon/>
                                                        <i>تماس تلفنی</i>
                                                    </a>
                                                </b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : null
            }
        </>
    );
};